import { createFileRoute } from '@tanstack/react-router';

import { LookaheadPage } from '@/features/siteplan/lookahead-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/lookahead')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <LookaheadPage projectId={projectId} />;
}
